import {useState} from 'react';

export function HashRouter(props) {
  const path = "#" + props.path;
  const [hash, setHash] = useState(document.location.hash);

  window.addEventListener('hashchange', event => {
    setHash(window.location.hash);
  });

  if (hash.startsWith(path)) {
    return props.component;
  }

  return null;
}
